import { useAcceptSchoolInvitationMutation } from '@/types/vue-apollo-helpers';

export function useAcceptInvitation() {
  const { mutate: acceptInvitation, loading, error, onDone } = useAcceptSchoolInvitationMutation();

  return {
    acceptInvitation,
    loading,
    error,
    onDone,
  };
}
